import styled from 'styled-components';

import Account from 'pages/account';

export const IconContainer = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  margin: 0;
  padding: 0;
`;

export const SideNavContainer = styled.div<{ visible: boolean }>`
  display: flex;
  flex-direction: column;
  background: ${Styles.color.white};
  position: absolute;
  z-index: ${Styles.zIndex.top};
  top: ${Styles.layout.navHeight.desktop};
  left: 0;
  height: calc(100vh - ${Styles.layout.navHeight.desktop});
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 10%);
  transform: ${({ visible }) => (visible ? 'translateX(0)' : 'translateX(-100%)')};
  transition: transform 0.3s ease-in-out;
  padding: 2rem;
  overflow-y: auto;
`;

export const StyledAccount = styled(Account)`
  margin: 0;
  padding: 0;
  a {
    color: ${Styles.color.tertiary};
  }
`;
